// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3BxIN","colMaxWidth":"Table_colMaxWidth__2qGaC"};